// The shared chrome: everything both apps must render identically.
// Tokens ship separately as ./tokens.css - CSS cannot come through this barrel.

export { ButtonLink, type ButtonVariant } from "./ButtonLink";
export { ContourCanvas } from "./ContourCanvas";
export { CONTOUR_STYLES, drawContours, type ContourColors, type ContourStyle, type ContourVariant } from "./contours";
export { BookIcon, CheckIcon, ChevronIcon, CopyIcon, CrownIcon, ExternalIcon, MoonIcon, PinIcon, SortIcon, SunIcon } from "./icons";
export { BittensorIcon, DiscordIcon, GithubIcon } from "./brand-icons";
export { NavMenu, type MenuItem } from "./NavMenu";
export { NavDrawer } from "./NavDrawer";
export { SiteFooter } from "./SiteFooter";
export { NAV_HEIGHT_PX, SiteNav } from "./SiteNav";
export { SomaMark } from "./SomaMark";
export { Spinner } from "./Spinner";
export { StatusPill } from "./StatusPill";
export { ThemeSwitch } from "./ThemeSwitch";
export { LOGO_DOTS, LOGO_DOT_R, LOGO_LINKS, LOGO_VIEWBOX, linkPath } from "./brand";
export { siteCopy, type SiteCopy } from "./site";
export {
  THEME_BOOT_SCRIPT,
  THEME_CLASS,
  THEME_STORAGE_KEY,
  applyTheme,
  isTheme,
  readTheme,
  readToken,
  subscribeTheme,
  type Theme,
} from "./theme";
export type { Link, LinkColumn, Status } from "./types";
export { useReducedMotion } from "./useReducedMotion";
export { useTheme, type ThemeState } from "./useTheme";
export { cn, onSite } from "./utils";
